<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            Apelidos bloqueados
            <button
              type="submit"
              class="btn btn-primary"
              @click="cadastrar_blockname = true"
              data-toggle="modal"
              data-target="#cadastrar-modal"
              style="margin-left: 15px"
            >
              <i class="fa-solid fa-plus" style="margin-right: 5px"></i>
              Cadastrar apelido
            </button>
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/apelidos_bloqueados">Apelidos bloqueados</a></li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <div>
    <!-- TABELA DE blocknames -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Apelidos bloqueados</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th style="width: 30px">Seq</th>
                <th>Nome</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(blockname, index) in blocknames" :key="logo">
                <td data-label="Seq" style="text-transform: uppercase;">{{ index + 1 }}</td>
                <td data-label="Nome" style="text-transform: uppercase;">{{ blockname.name }}</td>

                <td data-label="Ações">
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a
                      href="#"
                      @click="(blockname_selecionado = blockname), (editar_blockname = true)"
                      data-toggle="modal"
                      data-target="#editar-modal"
                      class="dropdown-item"
                    >
                      <i class="fa-solid fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>
                    <div class="dropdown-divider"></div>
                    <a href="#" @click="deletar(blockname)" class="dropdown-item">
                      <i class="fa-solid fa-trash"></i>
                      &nbsp;&nbsp; Deletar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + blocknames.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- NOVO MODELO TESTE MODAL EDITAR-->
    <!-- NOVO PADRÃO EDITAR MODAL-->
    <!-- EDITAR BLOCKNAME-->
    <div
      class="modal fade"
      id="editar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      @click.self="editar_blockname = false"
      @keydown.esc="editar_blockname = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body" v-if="editar_blockname">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
              <editar-blockname :blockname="blockname_selecionado" :closeModal="closeModal" :acaoRealizada="acaoRealizada" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- CADASTRAR BLOCKNAME-->
    <div
      class="modal fade"
      id="cadastrar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      @click.self="cadastrar_blockname = false"
      @keydown.esc="cadastrar_blockname = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body" v-if="cadastrar_blockname">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
              <cadastrar-blockname :closeModal="closeModal" :acaoRealizada="acaoRealizada" />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      blockname_selecionado: "",
      filtro: "",
      paginas: [],
      blocknames: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_blockname: false,
      cadastrar_blockname: false,
    };
  },

  mounted() {
    console.log(this.blocknames);
    this.buscarBlocknames();
  },

  methods: {
    acaoRealizada(acao) {
      if (acao == "editar") {
        this.editar_blockname = false;
        this.buscarBlocknames();
      }

      if (acao == "cadastrar") {
        this.cadastrar_blockname = false;
        this.buscarBlocknames();
      }
    },

    closeModal() {
      this.editar_blockname = false;
      this.cadastrar_blockname = false;
    },

    editarBlockname(blockname) {
      this.blockname_selecionado = blockname;
      this.editar_blockname = true;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarBlocknames();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarBlocknames();
      }
    },

    buscarBlocknames() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/blocknames/search`, data)
        .then((response) => {
          this.blocknames = response.data.blocknames;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    deletar(blockname) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: blockname.id,
            };

            axios
              .post(`/admin/blockname/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessage("Blockname deletado!");
                this.buscarBlocknames();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarBlocknames();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
